export const init = () => {
  if (document.querySelector('.s-banner-v__inner')) {

    let imageComparison = document.querySelectorAll('.s-banner-v__inner');

    imageComparison.forEach(function (cur) {

      let divider = cur.querySelector('.fake-cover');
      let imageAfter = cur.querySelector(".image-after");
      let image = imageAfter.querySelector(".img");
      let imageComparisonWidth = cur.offsetWidth; // 1696

      image.style.width = `${imageComparisonWidth}px`;
      let x;
      let y;
      let detectPrcent;
      let rect = cur.getBoundingClientRect();

      function moveDivider(event) {
        y = (document.documentElement.clientWidth - imageComparisonWidth) / 2; // cur.curElement.clientWidth = 1903

        if (event.type === "touchmove") {
          x = imageComparisonWidth - (event.touches[0].clientX - y);
        }

        if (event.type === "mousemove") {
          x = imageComparisonWidth - (event.clientX - y);
        }

        if (event.type === "mousemove" || event.type === "touchstart" || event.type === "touchmove") {


          detectPrcent = (x / imageComparisonWidth * 100);


          //  if (detectPrcent == 50) {
          //   cur.querySelector('.image-labels div:first-of-type').style.visibility = "visible";
          //   cur.querySelector('.image-labels div:last-of-type').style.visibility = "visible";
          // }

          console.log(detectPrcent);

          if (detectPrcent > 70) {
            cur.querySelector('.image-labels div:first-of-type').classList.add("active");
            cur.querySelector('.image-labels div:last-of-type').classList.remove("active");
          }
          else if (detectPrcent < 70 && detectPrcent > 30) {
            cur.querySelector('.image-labels div:first-of-type').classList.remove("active");
            cur.querySelector('.image-labels div:last-of-type').classList.remove("active");
          }
          else if (detectPrcent < 30) {
            cur.querySelector('.image-labels div:last-of-type').classList.add("active");
            cur.querySelector('.image-labels div:first-of-type').classList.remove("active");
          }




          imageAfter.style.width = `${x}px`;
          divider.style.width = `${x}px`;
        } else if (event.type === "mouseleave") {
          rect = cur.getBoundingClientRect();
          const mouseX = event.clientX;
          const mouseY = event.clientY;


          if (detectPrcent > 50 && mouseY > rect.top && mouseY < rect.bottom) {
            imageAfter.style.width = `${imageComparisonWidth}px`;
            divider.style.width = `${imageComparisonWidth}px`;

          } else if (detectPrcent < 50 && mouseY > rect.top && mouseY < rect.bottom) {
            imageAfter.style.width = `0`;
            divider.style.width = `0`;
          }

        }

      }

      cur.addEventListener('mousemove', moveDivider);
      cur.addEventListener('mouseleave', moveDivider);


      cur.addEventListener('touchmove', moveDivider);
      cur.addEventListener('touchstart', moveDivider);
    })

  }
};


